<div class="title" mat-dialog-title>
  <span class="title-content">Revenue Summary</span>
  <mat-icon class="close" [mat-dialog-close]="true" aria-hidden="false">close</mat-icon>
</div>
<mat-dialog-content>
  <app-monthly-totals-smart
    [borrowerId]="data.borrowerId"
    [readOnly]="data.readOnly"
  ></app-monthly-totals-smart>
</mat-dialog-content>
